import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Apple, Brain, Shield, Pill } from 'lucide-react';
import { Button } from './Button';
export function Benefits() {
  const scrollToOffer = () => {
    window.location.href = 'https://empresagama.com/cart/47409116315797:1';
  };
  const benefits = [{
    icon: <Clock className="w-6 h-6 text-navy" data-id="element-13" />,
    title: 'El Protocolo 48h Paso a Paso',
    description: 'Qué comer y qué hacer desde que despiertas hasta que duermes.'
  }, {
    icon: <Apple className="w-6 h-6 text-navy" data-id="element-14" />,
    title: 'Nutrición de Impacto',
    description: 'Los 5 alimentos exactos que actúan como "limpiadores" de niebla.'
  }, {
    icon: <Brain className="w-6 h-6 text-navy" data-id="element-15" />,
    title: 'La Técnica de Vaciado de RAM',
    description: 'Cómo liberar espacio mental para dejar de sentirte abrumada.'
  }, {
    icon: <Shield className="w-6 h-6 text-navy" data-id="element-16" />,
    title: 'El Escudo contra el Burnout',
    description: 'Rutinas de 5 minutos para mantener la claridad toda la semana.'
  }, {
    icon: <Pill className="w-6 h-6 text-navy" data-id="element-17" />,
    title: 'Guía de Suplementación Básica',
    description: 'Lo que tu cerebro realmente necesita para funcionar bien en Chile.'
  }];
  return <section className="py-24 bg-cream" data-id="element-18">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-21">
            Qué vas a lograr
          </h2>
          <div className="w-24 h-1 bg-mint mx-auto" data-id="element-22"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-23">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-mint/20 hover:shadow-md transition-shadow" data-id="element-24">
              <div className="w-12 h-12 bg-mint-light rounded-xl flex items-center justify-center mb-6" data-id="element-25">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-26">{benefit.title}</h3>
              <p className="text-navy/70 leading-relaxed" data-id="element-27">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-28">
          <Button onClick={scrollToOffer} className="w-full sm:w-auto" data-id="element-29">
            QUIERO RECUPERAR MI ENFOQUE AHORA
          </Button>
        </div>
      </div>
    </section>;
}